import React, { useState } from 'react'
import PenaltyTypePill from '../PenaltyTypePill'
import StatusPill from '../StatusPill'
import ModalDialog from '../../layouts/ModalDialog'
import DisciplinaryRecordDetails from '../../partials/students/DisciplinaryRecordDetails'
import ArrowIcon from '../icons/ArrowIcon'

const DisciplinaryRecordCard = ({record}) => {
    const [readingDisciplinaryRecord, setReadingDisciplinaryRecord] = useState(false)

    const openDisciplinaryRecord = () => {
        setReadingDisciplinaryRecord(true)
    }

    const closeDisciplinaryRecord = () => {
        setReadingDisciplinaryRecord(false)
    }
    
    return (
        <>
            <div className='w-full p-[10px] rounded bg-gray-50'>
                <div className='w-full mb-2'>
                    <label className='block text-sm text-gray-500 mb-[5px]'>Description</label>
                    <p className='text-[13px] text-gray-700'>{record.description.slice(1, 100)}{record.description.length > 100 ? '...' : ''}</p>
                </div>
                <div className='flex items-center gap-x-[20px]'>
                    <div className='w-'>
                        <label className='block text-xs text-gray-500 mb-[5px]'>Penalty type</label>
                        <PenaltyTypePill type={record.penalty.type} />
                    </div>

                    <div className='w-'>
                        <label className='block text-xs text-gray-500 mb-[5px]'>Penalty status</label>
                        <StatusPill status={record.penalty.status} />
                    </div>
                </div>
                <div className='mt-[10px] w-full pt-[10px] border-t border-gray-300'>
                    <button onClick={()=>{openDisciplinaryRecord()}} className='flex items-center justify-center gap-x-[5px] text-sm font-space-grotesk font-[500]'>Read more <ArrowIcon className={`w-3 h-3`} />  </button>
                </div>
            </div>

            <ModalDialog
                shown={readingDisciplinaryRecord} 
                closeFunction={()=>{closeDisciplinaryRecord()}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle={`Disciplinary record details`}
                maxWidthClass='max-w-xl'
                hideActions={true}
            >
                <DisciplinaryRecordDetails 
                    record={record} 
                    close={()=>closeDisciplinaryRecord()} 
                />
            </ModalDialog>
        </>
    )
}

export default DisciplinaryRecordCard